// @ts-nocheck
import { Alert, Box } from '@mui/material';
import React from 'react';
import { flexGap2, flexRowGap2, fullWidth } from '../../../../../constants/lkCadastr/cadastrStorage';
import { Text, TextTitle } from '../../../../Text';
import { AsyncAutocomplete } from '../../../../AutoCompletes/AsyncAutocomplete';
import { getWasteTypesRequest } from '../../../../../api/wasteTypeApi';
import { DEFAULT_AUTOCOMPLETE_FIELD } from '../../../../Inputs/CustomAutocomplete';
import { getReferencesRequest } from '../../../../../api/referenceApi';
import { WASTE_MANAGEMENT_TYPES_URL } from '../../../../../constants/urls';
import AddButton from '../../../../Buttons/AddButton';
import {
  FORM6_TRANSPORTED_WASTE,
  getInitialForm6TransportedWaste,
} from '../../../../../constants/lkCadastr/cadastrForm6';
import DeleteButton from '../../../../Buttons/DeleteButton';
import { filterActivityType } from '../../../../../helpers/cadastreForms/cadastreFormsPrepareFrontend';
import CustomInput from '../../../../Inputs';
import { compareId } from '../../../../../helpers';
import { getSubjectsRequest } from '../../../../../api/subjectApi';

export function Form6TransportedWaste({
  transportedWastes,
  onChange,
  actualVolume,
  changeItemFormByField,
  setCreateSubjectInfo,
  isDemo,
  tab,
  openDeleteModal,
  deleteForm6Entity,
}) {
  return (
    <Box sx={flexGap2}>
      <Box sx={flexRowGap2}>
        <TextTitle h3>
          Транспортируемые отходы
        </TextTitle>
        {!isDemo && (
          <AddButton
            variant="outlined"
            onClick={() => changeItemFormByField([
              ...transportedWastes,
              getInitialForm6TransportedWaste(),
            ])}
          >
            Добавить транспортируемый отход
          </AddButton>
        )}
      </Box>
      {transportedWastes.map((transportedWaste, transportedWasteIndex) => {
        if (tab !== transportedWaste.randId) return null;

        const changeItem = (field, value) => onChange(`${FORM6_TRANSPORTED_WASTE}.${transportedWasteIndex}.${field}`, value, transportedWasteIndex);
        const isDisabledAcceptingSubject = compareId(transportedWaste.accept_subject_id?.name, 0);

        const onDeleteTransportedWaste = async () => {
          if (transportedWaste?.id) {
            const deletedTransportedWaste = await deleteForm6Entity({ transportedWasteId: transportedWaste.id });

            if (!deletedTransportedWaste) return;
          }

          const cloneArray = transportedWastes.slice();
          cloneArray.splice(transportedWasteIndex, 1);

          changeItemFormByField(cloneArray, 'delete');
        };

        const isWasteZero = compareId(transportedWaste.waste_type_id?.label, 0);

        return (
          <>
            <Box key={transportedWaste.randId} sx={flexGap2}>
              <Box display="flex" alignItems="center" mb={1} gap={3}>
                <TextTitle>
                  Транспортируемый отход
                  №
                  {transportedWasteIndex + 1}
                </TextTitle>
                {!isDemo && transportedWastes.length > 1 && (
                  <DeleteButton onClick={() => openDeleteModal(onDeleteTransportedWaste, transportedWasteIndex, 'Транспортируемый отход')}>
                    Удалить транспортируемый отход
                  </DeleteButton>
                )}
              </Box>
              <Box sx={flexGap2}>
                <Box>
                  <Text className="mute">Наименование отхода</Text>
                  <AsyncAutocomplete
                    canBeZero
                    validImmediately={!isWasteZero}
                    debounceTime={0}
                    disabled={isDemo}
                    sx={{ width: '100%' }}
                    request={getWasteTypesRequest}
                    value={transportedWaste.waste_type_id}
                    optionField={{ ...DEFAULT_AUTOCOMPLETE_FIELD, label: 'name' }}
                    onChange={(e, value) => changeItem('waste_type_id', value)}
                  />
                </Box>
                <Box>
                  <Text className="mute">Код отхода по ФККО</Text>
                  <AsyncAutocomplete
                    validImmediately={!isWasteZero}
                    debounceTime={0}
                    disabled={isDemo || isWasteZero}
                    sx={{ width: '100%' }}
                    request={getWasteTypesRequest}
                    value={transportedWaste.waste_type_id}
                    optionField={{ ...DEFAULT_AUTOCOMPLETE_FIELD, label: 'code' }}
                    onChange={(e, value) => changeItem('waste_type_id', value)}
                  />
                </Box>
                <Box>
                  <Text className="mute">Наименование цели вывоза *</Text>
                  <AsyncAutocomplete
                    required
                    multiple
                    validImmediately={!isWasteZero}
                    debounceTime={0}
                    disabled={isDemo || isWasteZero}
                    request={(params) => getReferencesRequest({
                      url: WASTE_MANAGEMENT_TYPES_URL,
                      params,
                      filter: filterActivityType,
                    })}
                    sx={{ width: '320px' }}
                    value={transportedWaste.waste_management_type_ids}
                    onChange={(e, value) => changeItem('waste_management_type_ids', value)}
                  />
                </Box>
              </Box>
              <Box sx={flexGap2}>
                <TextTitle h3>
                  Количество транспортируемых отходов
                </TextTitle>
                <Box>
                  <Text className="mute">т/год</Text>
                  <CustomInput
                    validImmediately
                    debounceTime={0}
                    disabled={isDemo}
                    type="number"
                    decimalScale={3}
                    value={transportedWaste.actual_volume_transported_waste}
                    onChange={(e, value) => changeItem('actual_volume_transported_waste', value)}
                    sx={fullWidth}
                  />
                </Box>
              </Box>
            </Box>
            <Box sx={flexGap2}>
              <Alert severity="info">
                Для поиска организации в справочнике введите наименование или ИНН в графу «Юридическое лицо (индивидуальный предприниматель), принявшее транспортируемые отходы»,  в случае отсутствия нажмите кнопку «+Создать субъект» и добавьте организацию в справочник.
              </Alert>
              <TextTitle h3>
                Юридическое лицо (индивидуальный предприниматель),
                принявшее транспортируемые отходы
              </TextTitle>
              <Box>
                <Text className="mute">Наименование (ФИО)</Text>
                <AsyncAutocomplete
                  canBeZero
                  validImmediately={!isDisabledAcceptingSubject}
                  debounceTime={0}
                  disabled={isDemo}
                  name="accept_subject_id"
                  sx={fullWidth}
                  request={(params) => getSubjectsRequest({ params })}
                  noOptionComponent={(
                    <AddButton
                      variant="outlined"
                      onClick={() => setCreateSubjectInfo({ index: transportedWasteIndex, fieldName: 'accept_subject_id' })}
                    >
                      Создать субъект
                    </AddButton>
                  )}
                  value={transportedWaste.accept_subject_id}
                  onChange={(e, value) => { changeItem('accept_subject_id', value); actualVolume.importfromxlsx = false; }}
                />
              </Box>
              <Box>
                <Text className="mute">ИНН</Text>
                <CustomInput
                  disabled
                  value={transportedWaste.accept_subject_id?.inn}
                  sx={fullWidth}
                />
              </Box>
            </Box>
          </>
        );
      })}
    </Box>
  );
}
